import React, { useState } from "react";
import { Form, Dropdown } from "react-bootstrap";

const SearchableDropdownGeneral = ({ optionsArray = [], selectedUser, setSelectedUser }) => {
    
    const [users] = useState(optionsArray);
    const [filteredUsers, setFilteredUsers] = useState(users);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSelectedUser((prev) => {
            return {
                manualName: value
            }
        });
        const filtered = users.filter((user) =>
            `${user.firstName} ${user.lastName}`
                .toLowerCase()
                .includes(value.toLowerCase())
        );
        setFilteredUsers(filtered);
    };

    const handleSelect = (user) => {
        setFilteredUsers([]);
        setDropdownOpen(false);
        setSelectedUser(user);
    };

    const handleInputClick = () => {
        setDropdownOpen(true);
        setFilteredUsers(users);
    };

    return (
        <div>
            <Form.Control
                type="text"
                value={selectedUser?.firstName ? `${selectedUser?.firstName} ${selectedUser?.lastName}` : selectedUser?.manualName ? selectedUser.manualName : ''}
                placeholder="Kunden suchen"
                onChange={handleInputChange}
                onClick={handleInputClick}
                onBlur={() => setTimeout(() => setDropdownOpen(false), 100)}
            />
            {dropdownOpen && filteredUsers?.length > 0 && (
                <Dropdown.Menu
                    show
                    style={{
                        display: "block",
                        position: "absolute",
                        width: "90%",
                        maxHeight: "300px",
                        overflowY: "auto",
                        zIndex: 1000,
                    }}
                >   
                    <Dropdown.Item
                        key={0}
                        onClick={() => {setSelectedUser(null)}}
                    >
                        Keine Auswahl
                    </Dropdown.Item>
                    {filteredUsers.map((user) => (
                        <Dropdown.Item
                            key={user.id}
                            onClick={() => handleSelect(user)}
                        >
                            {user.firstName} {user.lastName}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            )}
        </div>
    );
};

export default SearchableDropdownGeneral;
